import "./PocketPal.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import VoiceWidget from "./sections/VoiceWidget";
import HowICanHelp from "./sections/HowICanHelp";
import Footer from "@/reusable_sections/Footer";
export default function PocketPalPage() {
  return <div>
      <Header />
      <Hero />
      <VoiceWidget />
      <HowICanHelp />
      <Footer />
    </div>;
}